const checkIsStoryBookPath = (defaultPath = ''): string => {
  const isInStory = process.env.REACT_APP_TEST_API_PREFIX_ENABLED === 'true';

  return isInStory
    ? `${defaultPath ? defaultPath + '/test' : '/test/'}`
    : defaultPath || '/';
};

export { checkIsStoryBookPath };
